module.exports = new __parcel__URL__("logo-se-mer-biodiversite.0111a8a2.jpg").toString();